import { render, staticRenderFns } from "./NotifyMsg.vue?vue&type=template&id=626479c9&scoped=true&"
import script from "./NotifyMsg.vue?vue&type=script&lang=js&"
export * from "./NotifyMsg.vue?vue&type=script&lang=js&"
import style0 from "./NotifyMsg.vue?vue&type=style&index=0&id=626479c9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "626479c9",
  null
  
)

export default component.exports